/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_sharetrip.js                                                               */
/**********************************************************************************************************************/
/* Controller GUI */
HafasWebapp.prototype.Controller.ShareTrip = {
  currentConnection: null,
  currentOverlay: null,
  currentShortLink: null,
  currentConntectionText: "",
  currentConntectionTitle: "",

  showOverlay: function (data) {
    var _me = this;
    var results = this.Controller.TP.instance.getResults(data.connectionType);
    var currConnection;
    this.Controller.ShareTrip.currentShortLink = null;

    if (Hafas.Modules.History)
      Hafas.Modules.History.addSubView("/GUI/shareTrip/closeOverlay", "ShareTripPopup", {});

    if (data.connectionType == 'PT') {
      currConnection = results[data.arrayIdx - 1];
    }
    else {
      currConnection = results[data.arrayIdx - 1].resolvedConnection;
    }
    this.Controller.ShareTrip.currentConnection = currConnection;

    Hafas.Modules.Render.render(
      {
        template: 'TP_AtomShareTrip',
        file: 'common.overlays.html',
        model: {
          connection: currConnection
        }
      }, function (outputHTML) {
        _me.Controller.ShareTrip.currentOverlay = Hafas.Core.newType("HafasOverlay", {
          app: _me,
          outputHTML: outputHTML,
          title: Hafas.Modules.i18n.get('ShareTrip.t_N_OverlayTitle'),
          cssClass: 'lyr_shareOverlay',
          onClose: function () {
            if (Hafas.Modules.History)
              Hafas.Modules.History.removeCurrentStep("ShareTripPopup");
          }
        });
        Hafas("#HFS_ShareTripLinkInput").onblur = function () {
          var shortHint = Hafas("#HFS_ShareTripLink_ShortHint");
          shortHint.innerHTML = "";
          shortHint.removeClassName("OK");
          shortHint.removeClassName("error");
        };
        Hafas.bind(_me.Controller.ShareTrip.showLinkView, _me)();

        // Tracking
        Hafas.ps.pub('/tracking/event/button-share', [ { typ: 'event', key: 'button-share' } ]);
        Hafas.ps.pub('/tracking/event/share-pressed', [ { typ: 'event', key: 'share-pressed' } ]);
      });
  },

  showLinkView: function () {

    var me = this;
    Hafas.bind(me.Controller.ShareTrip.createShortLink, me)(function (hasLinkError, linkUrl) {
      Hafas.bind(me.Controller.ShareTrip.createConnectionText, me)(function (hasTextError, connectionAsText) {
        Hafas.bind(me.Controller.ShareTrip.renderLinkView, me)(hasLinkError, linkUrl, connectionAsText);
      });
    });

  },
  createShortLink: function (callback) {
    var shareTripReq = Hafas.Core.newType('hafasHCIRequestObject', 'ShareTrip', {
      'req.ctxRecon': this.Controller.ShareTrip.currentConnection.ctxRecon,
      'req.mode': 'link'
    });

    var shareTrip = Hafas.Core.newType('hafasHCIRequest', {requests: [shareTripReq]});

    Hafas.Core.newType("hafasRequest", {
      hciRequestObj: shareTrip,
      requestType: 'hci',
      callback: Hafas.bind(function (reqResult) {
        var errorStatus = false;
        var linkUrl = null;
        if (typeof reqResult.resultStatus == 'undefined' || typeof reqResult.resultStatus[0] == 'undefined' || reqResult.resultStatus[0].error) {
          errorStatus = true;
        } else {
          var result = reqResult.svcResL[0].res;
          linkUrl = result.common.urlL[result.urlL[0]].url;
          this.Controller.ShareTrip.currentShortLink = linkUrl;
        }
        callback(errorStatus, linkUrl);
      }, this)
    });
  },
  createConnectionText: function (callback) {
    var connection = this.Controller.ShareTrip.currentConnection;
    var title = Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_1") + " " + connection.dep.locResolved.name + " " + Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_2") + " " + connection.arr.locResolved.name;
    this.Controller.ShareTrip.currentConntectionTitle = title;
    var shareTripReq = Hafas.Core.newType('hafasHCIRequestObject', 'ShareTrip', {
      'req.ctxRecon': connection.ctxRecon,
      'req.mode': 'text'
    });

    var shareTrip = Hafas.Core.newType('hafasHCIRequest', {requests: [shareTripReq]});

    Hafas.Core.newType("hafasRequest", {
      hciRequestObj: shareTrip,
      requestType: 'hci',
      callback: Hafas.bind(function (reqResult) {
        var errorStatus = false;
        var connectionAsText = null;
        if (typeof reqResult.resultStatus == 'undefined' || typeof reqResult.resultStatus[0] == 'undefined' || reqResult.resultStatus[0].error || reqResult.svcResL[0].res.text == undefined) {
          errorStatus = true;
        } else {
          var result = reqResult.svcResL[0].res;
          connectionAsText = result.text;
        }

        this.Controller.ShareTrip.currentConntectionText = connectionAsText;
        callback(errorStatus, connectionAsText, title);
      }, this)
    });
  },

  createShareButtons: function (linkUrl, connectionAsText) {
    var connection = this.Controller.ShareTrip.currentConnection;

    var buttonHolder = Hafas("#HFS_ShareTripLinkButtonHolder");
    var html = "";
    var isMobile = Hafas.Util.getPlatform().isMobile;
    var connectionDates = {
      arrTime: Hafas.Util.date.hciTime2stringShort(connection.arr.aTimeS),
      depTime: Hafas.Util.date.hciTime2stringShort(connection.dep.dTimeS),
      date: Hafas.Util.date.hciDate2string(connection.date)
    };

    if (typeof navigator.share === "undefined") {
      for (var i = 0; i < Hafas.Config.Switches.useShareTrip.enabledLinkButtons.length; i++) {
        var type = Hafas.Config.Switches.useShareTrip.enabledLinkButtons[i];
        if (this.Controller.ShareTrip.ShareServices[type]) {
          var linkButtonType = this.Controller.ShareTrip.ShareServices[type];
          if (!isMobile && linkButtonType.onlyMobil)
            continue;
          var model = {
            text: Hafas.Modules.i18n.get(linkButtonType.text),
            icnClass: linkButtonType.icnClass,
            href: linkButtonType.createHref(linkUrl, connection, connectionDates, connectionAsText)
          };
          html += Hafas.Modules.Render.renderTemplate("TP_ShareTripLinkButton", model);
        }
      }
    }
    else {
      var type = "ShareAPI";
      if (this.Controller.ShareTrip.ShareServices[type]) {
        var linkButtonType = this.Controller.ShareTrip.ShareServices[type];
        var model = {
          text: Hafas.Modules.i18n.get(linkButtonType.text),
          icnClass: linkButtonType.icnClass,
          onclick: "Hafas.ps.pub('/GUI/shareTrip/shareWithAPI', ['" + encodeURI(linkUrl) + "']); return false;"
        };
        html += Hafas.Modules.Render.renderTemplate("TP_ShareTripLinkButton", model);
      }
    }

    buttonHolder.innerHTML = html;
  },

  renderLinkView: function (hasError, linkUrl, connectionAsText, title) {
    if (hasError) {
      var resultTpl = 'TP_ShareTripError';
      var statusText = Hafas.Modules.i18n.get('ShareTrip.t_N_Error');
      Hafas("#HFS_ShareTripLinkCreateRow").innerHTML = Hafas.Modules.Render.renderTemplate(resultTpl, {statusText: statusText});
    } else {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_ShareTripLinkCreateRow"), false);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_ShareTripLinkSendRow"), true);
      var input = Hafas("#HFS_ShareTripLinkInput");
      input.value = linkUrl;
      input.onfocus = function () {
        Hafas.Util.gui.selectInputText(input);
      };

      Hafas.bind(this.Controller.ShareTrip.createShareButtons, this)(linkUrl, connectionAsText, title);
      this.Controller.ShareTrip.currentOverlay.redraw(this.Controller.ShareTrip.currentOverlay);
    }
  },

  copyLink: function () {

    var inputElem = Hafas("#HFS_ShareTripLinkInput");
    if (!Hafas.Util.gui.hasFocus(inputElem))
      inputElem.focus();
    inputElem.setSelectionRange(0, 99999);

    var succeeded;

    try {
      succeeded = document.execCommand("copy");
    }
    catch (err) {
      succeeded = false;
    }
    var shortHint = Hafas("#HFS_ShareTripLink_ShortHint");
    if (succeeded) {
      shortHint.innerHTML = Hafas.Modules.i18n.get("ShareTrip.t_N_CopyDone");
      shortHint.addClassName("OK");
    }
    else {
      shortHint.innerHTML = Hafas.Modules.i18n.get("ShareTrip.t_N_CopyFail");
      shortHint.addClassName("error");
    }

  },
  shareWithAPI: function (url, title) {
    var data = {
      text: this.Controller.ShareTrip.currentConntectionText,
      title: this.Controller.ShareTrip.currentConntectionTitle
    };
    navigator.share(data);

  },
  ShareServices: {
    Mail: {
      text: "ShareTrip.t_N_MailButtonText",
      icnClass: "haf_share_mail",
      onlyMobil: false,
      createHref: function (url, connection, connectionDates, connectionAsText) {
        var headerText = Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_1") + " " + connection.dep.locResolved.name + " " + Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_2") + " " + connection.arr.locResolved.name;
        var bodyText = encodeURIComponent(connectionAsText);
        var href;
        href = "mailto:?subject=" + encodeURIComponent(headerText) + "&body=" + bodyText;
        return href;
      }
    },
    SMS: {
      text: "ShareTrip.t_N_SMSButtonText",
      icnClass: "haf_share_sms",
      onlyMobil: true,
      createHref: function (url, connection, connectionDates) {
        var headerText = Hafas.Modules.Render.renderTemplate("TP_ShareTripShortText", {
          connection: connection,
          lineBreak: "",
          shortLink: encodeURI(url),
          connectionDates: connectionDates
        });
        var href;
        href = "sms:?&body=" + encodeURIComponent(headerText);
        return href;
      }
    }
    ,
    WhatsApp: {
      text: "ShareTrip.t_N_WhatsAppButtonText",
      icnClass: "haf_share_whatsapp",
      onlyMobil: true,
      createHref: function (url, connection, connectionDates) {
        var headerText = Hafas.Modules.Render.renderTemplate("TP_ShareTripShortText", {
          connection: connection,
          lineBreak: "",
          shortLink: encodeURI(url),
          connectionDates: connectionDates
        });
        var href = "https://api.whatsapp.com/send?text=" + encodeURIComponent(headerText);
        return href;
      }
    },
    Twitter: {
      text: "ShareTrip.t_N_TwitterButtonText",
      icnClass: "haf_share_twitter",
      onlyMobil: false,
      createHref: function (url, connection, connectionDates) {
        var headerText = Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_1") + " " + connection.dep.locResolved.name + " " + Hafas.Modules.i18n.get("ShareTrip.t_N_MailHead_2") + " " + connection.arr.locResolved.name;
        var href = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(headerText + "\n\n") + encodeURI(url);
        return href;
      }
    },
    FacebookMessenger: {
      text: "ShareTrip.t_N_FacebookButtonText",
      icnClass: "haf_share_facebook_messenger",
      onlyMobil: true,
      createHref: function (url, connection, connectionDates) {
        var href = "fb-messenger://share/?link=" + encodeURI(url);
        return href;
      }
    },
    Facebook: {
      text: "ShareTrip.t_N_FacebookButtonText",
      icnClass: "haf_share_facebook",
      onlyMobil: false,
      createHref: function (url, connection, connectionDates) {
        var href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(url);
        return href;
      }
    },
    ShareAPI: {
      text: "ShareTrip.t_N_ShareAPIButton",
      icnClass: "haf_action_share_inv",
      onlyMobil: true
    },
  },
  closeOverlay: function () {
    if (this.Controller.ShareTrip.currentOverlay != null) {
      this.Controller.ShareTrip.currentOverlay.close();
    }
    this.Controller.ShareTrip.currentOverlay = null;
  }
};
